import { render, staticRenderFns } from "./ai_detection.vue?vue&type=template&id=baea8812&"
import script from "./ai_detection.vue?vue&type=script&lang=js&"
export * from "./ai_detection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports